import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function HomeConnect() {
  return (
    <>
    <div className="home-connect">
        <div className="container">
            <div className="row justify-content-center">  

                <div className="col-lg-11">
                    <p className="connect-title">Creative Synergy</p>

                    <div className="connect-heading">
                        <h4 className="wow animate__animated animate__flipInX" data-wow-duration="1.4s" data-wow-delay="0.1s">Let’s</h4>
                        <h4 className="wow animate__animated animate__flipInX" data-wow-duration="1.4s" data-wow-delay="0.2s">Work</h4>
                        <h4 className="wow animate__animated animate__flipInX" data-wow-duration="1.4s" data-wow-delay="0.3s">Togther</h4>
                    </div>

                    <div className="connect-links">
                        <img src="/image/connect.svg" loading="lazy" className="img-responsive" alt="connect"/>
                        <ul>
                            <li><Link to="/contact" className="arrow-button">Send Us a Message <Icons name="Longarrow_right"/></Link></li>
                            <li><Link to="tel:+91-8397000603" className="arrow-button">Call Us: +91-8397000603</Link></li>
                        </ul>
                        <p>Inspired by our work? We would be delighted to help you create your dream interior!</p>
                    </div>
                </div>

            </div>
        </div>
    </div>  
    </>
  )
}
